import { render, staticRenderFns } from "./jigouDetail.vue?vue&type=template&id=cb26d6e2&"
import script from "./jigouDetail.vue?vue&type=script&lang=js&"
export * from "./jigouDetail.vue?vue&type=script&lang=js&"
import style0 from "./jigouDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports